<template>
    <injury-donut :docs="docs" field="condition" :colors="colors" :label-fn="injuryConditionLabel"
        :center-label="$t('statistics.distinct_particularities')" />
</template>

<script>
import InjuryDonut from './InjuryDonut.vue'

export default {
    name: 'InjuryConditionChart',
    components: { InjuryDonut },
    props: {
        docs: {
            type: Array,
            default: null,
        }
    },
    data() {
        return {
            colors: [
                '#339999', '#E85C5C', '#66CCCC', 'rgba(204,255,51,0.75)', '#009966',
            ],
        }
    },
}
</script>
